@if (supplierBaskets && supplierBaskets.length) {
    <div class="container-lg" #supplierBasketsContainer>
        @for (supplierBasket of supplierBaskets; track supplierBasket.id) {
            <section class="basket-supplier h-100 h-custom my-3" [id]="supplierBasket?.supplier?.id">
                <basket-supplier-feature
                    [companySetting]="companySetting"
                    [basketSupplierId]="supplierBasket.id"
                    [isEditableStep]="isEditableStep"
                    [basketToggleStatus]="basketToggleStatus"
                    [budgetOverruns]="budgetOverruns"
                    [resolvedPurchasingGroups]="resolvedPurchasingGroups"
                    [purchasingGroupVisible]="purchasingGroupVisible"
                    [companyCodeId]="companyCodeId"
                    (paymentTermsValidated)="onPaymentTermsValidated($event)"
                    (frameContractValidated)="onFrameContractValidated($event)"
                    (basketItemDeleted)="onDeleteBasketItem($event)"
                    (productNumberValidationMessageShown)="onShowProductNumberValidationMessage($event)"
                    (desiredDeliveryDateValidated)="onDeliveryDateValidated($event)"
                    (siteValidated)="onSiteValidated($event)"
                    (accountingValidated)="onAccountingValidated($event)"
                    (classificationValidated)="onClassificationValidated($event)"
                    (materialGroupValidated)="onMaterialGroupValidated($event)"
                ></basket-supplier-feature>
            </section>
        }
        <basket-currency-totals [currencyTotals]="currencyTotals" />
        @for (supplier of this.supplierBaskets; track supplier.id) {
            @for (item of supplier.basketItems; track item.id) {
                <div>
                    <section class="container-md mt-2">
                        @if (
                            checkSupplierItemAccounting(item) ||
                            checkSupplierItemClassification(item) ||
                            checkSupplierItemMaterialGroup(item) ||
                            checkSupplierItemPurchasingGroup(item)
                        ) {
                            <div class="alert alert-warning mb-0">
                                <strong class="me-2">
                                    {{ item.product.name }}
                                    <span
                                        class="cursor-pointer text-primary"
                                        (click)="scrollToItemById(supplier.supplier.id)"
                                    >
                                        ({{
                                            supplier.supplier.name
                                                | supplierDisplayName: supplier.supplier.supplierNumber
                                        }})
                                    </span>
                                    :
                                </strong>
                                @if (checkSupplierItemAccounting(item) || checkSupplierItemClassification(item)) {
                                    <span>
                                        {{ 'Nicht alle verpflichtenden Kontierungen wurden ausgefüllt.' | translate }}
                                    </span>
                                }
                                @if (checkSupplierItemMaterialGroup(item)) {
                                    <span>
                                        {{ 'Warengruppe ist ein Pflichtfeld.' | translate }}
                                    </span>
                                }
                                @if (checkSupplierItemPurchasingGroup(item)) {
                                    <span>
                                        {{
                                            'Für die ausgewählte Warengruppe ist keine Einkaufsgruppe für den aktuellen Buchungskreis hinterlegt.'
                                                | translate
                                        }}
                                    </span>
                                }
                            </div>
                        }
                    </section>
                </div>

                @if (showProductNumberValidationMessage) {
                    <section class="container-md mt-3">
                        <div class="alert alert-danger">
                            <strong class="me-2">
                                <span
                                    class="cursor-pointer text-primary"
                                    (click)="scrollToItemById(supplier.supplier.id)"
                                >
                                    {{ '{{productName}} - Bitte hinterlegen Sie eine Kundenartikelnummer' | translate: {
                                    productName: item?.product?.name } }}
                                </span>
                            </strong>
                        </div>
                    </section>
                }
            }
        }

        @if (budgetOverruns && budgetOverruns.length) {
            <section class="container-md mt-3">
                @for (overrun of budgetOverruns; track overrun.budgetId) {
                    <div class="row mb-1">
                        <div class="col">
                            <div class="alert alert-warning d-flex align-items-start">
                                <span class="fw-bold me-2"><em class="fas fa-exclamation-triangle text-warning"></em></span>
                                <div class="flex-grow-1">
                                    <div class="fw-bold">
                                        {{ 'Budget überschritten' | translate }}: {{ overrun.budgetName }}
                                    </div>
                                    <div class="small text-muted">
                                        {{ 'Limit' | translate }}:
                                        <display-currency [value]="overrun.softLimit?.amount" [currencyCode]="overrun.softLimit?.currency" />
                                        •
                                        {{ 'Überschreitung' | translate }}:
                                        <display-currency [value]="overrun.exceededAmount?.amount" [currencyCode]="overrun.exceededAmount?.currency" />
                                    </div>
                                    <div class="small">
                                        @let costCenter = getCostObject(budgetAssignmentType.COSTCENTER, overrun.costObjects);
                                        @let project = getCostObject(budgetAssignmentType.PROJECT, overrun.costObjects);
                                        @let account = getCostObject(budgetAssignmentType.ACCOUNT, overrun.costObjects);
                                        @if (costCenter) {
                                            <span class="me-2">
                                        {{ 'Kostenstelle' | translate }}: {{ costCenter.name || costCenter.key }}
                                    </span>
                                        }
                                        @if (project) {
                                            <span class="me-2">
                                        {{ 'Projekt' | translate }}: {{ project.name || project.key }}
                                    </span>
                                        }
                                        @if (account) {
                                            <span>
                                        {{ 'Sachkonto' | translate }}: {{ account.name || account.key }}
                                    </span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </section>
        }

        @if (!isDeliveryDateValid()) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{ 'Bitte geben Sie ein gewünschtes Lieferdatum an' | translate }}
                </div>
            </section>
        }
        @if (!isPaymentTermsValid()) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{ 'Zahlungsbedingung ist erforderlich' | translate }}
                </div>
            </section>
        }
        @if (!isFrameContractsValid()) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{ 'Rahmenvertrag ist erforderlich' | translate }}
                </div>
            </section>
        }
        @if (!isSiteValid()) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{ 'Standort ist erforderlich' | translate }}
                </div>
            </section>
        }
        @if (purchasingGroupValidationLoading) {
            <section class="container-md mt-3">
                <div class="alert alert-info">
                    {{ 'Einkaufsgruppen-Zuordnung wird geprüft' | translate }}
                </div>
            </section>
        }
        @if (hasPurchasingGroupAssignmentIssues()) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{
                        'Bitte wählen Sie eine Warengruppe mit gültiger Einkaufsgruppen-Zuordnung, bevor Sie fortfahren.'
                            | translate
                    }}
                </div>
            </section>
        }
        @if (showStepperButtons) {
            <section class="container-md">
                <div class="pt-5">
                    <div class="row justify-content-end basket-stepper-nav">
                        <div class="col-auto">
                            <button
                                class="btn btn-primary"
                                (click)="onClickNext()"
                                [disabled]="
                                    !isAccountingValid() ||
                                    !isClassificationValid() ||
                                    !isMaterialGroupValid() ||
                                    showProductNumberValidationMessage ||
                                    !isSiteValid() ||
                                    !isDeliveryDateValid() ||
                                    !isPaymentTermsValid() ||
                                    !isFrameContractsValid() ||
                                    purchasingGroupValidationLoading ||
                                    !isPurchasingGroupAssignmentValid()
                                "
                            >
                                {{ 'Weiter' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        }
    </div>
}
